"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddableType = void 0;
var tslib_1 = require("tslib");
var ManagedType_1 = require("./ManagedType");
var Type_1 = require("./Type");
var binding_1 = require("../binding");
var EmbeddableType = /** @class */ (function (_super) {
    tslib_1.__extends(EmbeddableType, _super);
    function EmbeddableType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EmbeddableType.prototype, "persistenceType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return Type_1.PersistenceType.EMBEDDABLE;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    EmbeddableType.prototype.createProxyClass = function () {
        return this.enhancer.createProxy(binding_1.Managed);
    };
    /**
     * @inheritDoc
     */
    EmbeddableType.prototype.createObjectFactory = function (db) {
        return binding_1.ManagedFactory.create(this, db);
    };
    /**
     * @inheritDoc
     */
    EmbeddableType.prototype.fromJsonValue = function (state, jsonObject, currentObject, options) {
        var obj = currentObject;
        if (jsonObject) {
            if (!(obj instanceof this.typeConstructor)) {
                obj = this.create();
            }
        }
        return _super.prototype.fromJsonValue.call(this, state, jsonObject, obj, options);
    };
    EmbeddableType.prototype.toString = function () {
        return "EmbeddableType(".concat(this.ref, ")");
    };
    return EmbeddableType;
}(ManagedType_1.ManagedType));
exports.EmbeddableType = EmbeddableType;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRW1iZWRkYWJsZVR5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJFbWJlZGRhYmxlVHlwZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEsNkNBQTRDO0FBQzVDLCtCQUF5QztBQUN6QyxzQ0FBcUQ7QUFLckQ7SUFBdUQsMENBQWM7SUFBckU7O0lBeUNBLENBQUM7SUFyQ0Msc0JBQUksMkNBQWU7UUFIbkI7O1dBRUc7YUFDSDtZQUNFLE9BQU8sc0JBQWUsQ0FBQyxVQUFVLENBQUM7UUFDcEMsQ0FBQzs7O09BQUE7SUFFRDs7T0FFRztJQUNILHlDQUFnQixHQUFoQjtRQUNFLE9BQU8sSUFBSSxDQUFDLFFBQVMsQ0FBQyxXQUFXLENBQUMsaUJBQU8sQ0FBQyxDQUFDO0lBQzdDLENBQUM7SUFFRDs7T0FFRztJQUNILDRDQUFtQixHQUFuQixVQUFvQixFQUFpQjtRQUNuQyxPQUFPLHdCQUFjLENBQUMsTUFBTSxDQUFDLElBQUksRUFBRSxFQUFFLENBQUMsQ0FBQztJQUN6QyxDQUFDO0lBRUQ7O09BRUc7SUFDSCxzQ0FBYSxHQUFiLFVBQWMsS0FBbUIsRUFBRSxVQUFnQixFQUFFLGFBQXVCLEVBQzFFLE9BQXdEO1FBQ3hELElBQUksR0FBRyxHQUFHLGFBQWEsQ0FBQztRQUV4QixJQUFJLFVBQVUsRUFBRTtZQUNkLElBQUksQ0FBQyxDQUFDLEdBQUcsWUFBWSxJQUFJLENBQUMsZUFBZSxDQUFDLEVBQUU7Z0JBQzFDLEdBQUcsR0FBRyxJQUFJLENBQUMsTUFBTSxFQUFFLENBQUM7YUFDckI7U0FDRjtRQUVELE9BQU8saUJBQU0sYUFBYSxZQUFDLEtBQUssRUFBRSxVQUFVLEVBQUUsR0FBRyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0lBQzlELENBQUM7SUFFRCxpQ0FBUSxHQUFSO1FBQ0UsT0FBTyx5QkFBa0IsSUFBSSxDQUFDLEdBQUcsTUFBRyxDQUFDO0lBQ3ZDLENBQUM7SUFDSCxxQkFBQztBQUFELENBQUMsQUF6Q0QsQ0FBdUQseUJBQVcsR0F5Q2pFO0FBekNZLHdDQUFjIn0=